import { NewRelicBrowser } from '@lib/newRelic/NewRelicBrowser';

import { EPictograms } from './model';

export const getPictogramIcon = (pictogram: EPictograms) => {
  try {
    return require(`./icons/${pictogram}.svg`);
  } catch (error) {
    NewRelicBrowser.agent.log(`Wrong pictogram path, pictogram: ${pictogram}`);
  }
};
